/**
 * Assessment Trigger Component
 *
 * Trigger: "completed this assessment"
 * Shows: assessment select
 */

import { useQuery } from '@tanstack/react-query';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box } from 'src/components/Box';
import { fetchAssessmentOptions } from 'src/models/assessment/assessment';
import { FormSelect } from 'src/shared/Forms/Fields/FormSelect';

import { TriggerComponentProps } from '../automationTriggers';

export const AssessmentTrigger: FC<TriggerComponentProps> = ({
  automation,
  index,
  readOnly,
}) => {
  const { t } = useTranslation();
  const { data: assessments = [] } = useQuery({
    queryKey: ['assessments', 'options'],
    queryFn: () => fetchAssessmentOptions(),
    staleTime: 60000,
  });

  const assessmentOptions = [
    { value: '', label: t('automations.triggers.anyAssessmentCap') },
    ...assessments.map((assessment) => ({
      value: String(assessment.id),
      label: assessment.name,
    })),
  ];

  const selectedAssessment = assessments.find(
    (a) => String(a.id) === String(automation.reminderTypeId)
  );

  if (readOnly) {
    if (selectedAssessment?.name) {
      return <span>{t('automations.triggers.completedAssessmentNamed', { name: selectedAssessment.name })}</span>;
    }
    return <span>{t('automations.triggers.completedAnyAssessment')}</span>;
  }

  // Edit mode
  return (
    <Box sx={{ maxWidth: 300 }}>
      <FormSelect
        name={`automations.${index}.reminderTypeId`}
        label={t('automations.triggerLabels.assessment')}
        options={assessmentOptions}
      />
    </Box>
  );
};
